import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import { avatarIcons, avatarIconsMr, avatarIconsMs } from "@utils/avatarInfo";

import {
  OuterWrapper,
  ContactInfo,
  ContactInfoOuter,
} from "./RelatedContacts.styled";

const RelatedContact = (props) => {
  const { t, contactData } = props;

  const avatarNumber = contactData.id % 10;

  const getAvatarImage = () => {
    let image = "";
    if (contactData?.courtesy === "MISTER") {
      image = avatarIconsMr[avatarNumber] ?? avatarIcons[1];
    } else if (contactData?.courtesy === "MISS") {
      image = avatarIconsMs[avatarNumber] ?? avatarIcons[4];
    } else {
      image = avatarIcons[avatarNumber] ?? avatarIcons[1];
    }
    return image;
  };

  return (
    <OuterWrapper>
      <Image
        src={getAvatarImage()}
        alt="Avatar"
        styles={{ height: "70px", width: "70px" }}
      />
      <ContactInfoOuter>
        <ContactInfo color="#474747" fontSize="16px">
          {contactData?.name}
        </ContactInfo>
        <ContactInfo color="#767676">{contactData?.phone}</ContactInfo>
        <ContactInfo color="#15aee5">{contactData?.email}</ContactInfo>
      </ContactInfoOuter>
      <ContactInfo color="#767676">{contactData?.job}</ContactInfo>
    </OuterWrapper>
  );
};

RelatedContact.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};
RelatedContact.defaultProps = {
  id: null,
};

export default withTranslation()(RelatedContact);
